var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isComponentReady)?_c('div',{staticClass:"l-ss-c-offers",class:_vm.wrapperClasses},[_c('offers-wrapper',_vm._g({ref:"offersWrapper",attrs:{"offers":_vm.offers,"view":_vm.options.view}},_vm.offersWrapperEventListeners))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }